import React, { Component } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import {Icon, Header, Grid, Form, Button, Message} from "semantic-ui-react";
import ReportTemplatesContainer from "../../../containers/report_template_container";
import {getModulesList} from "../../../data/report_module_api";
import {getTemplateDetails} from "../../../data/report_template_api";

const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

const move = (source, destination, droppableSource, droppableDestination) => {
    const sourceClone = Array.from(source);
    const destClone = Array.from(destination);
    const [removed] = sourceClone.splice(droppableSource.index, 1);

    destClone.splice(droppableDestination.index, 0, removed);

    const result = {};
    result[droppableSource.droppableId] = sourceClone;
    result[droppableDestination.droppableId] = destClone;

    return result;
};

const grid = 8;

const getItemStyle = (isDragging, draggableStyle) => ({
    userSelect: 'none',
    padding: grid * 2,
    margin: `0 0 ${grid}px 0`,
    borderRadius:'5px',
    background: isDragging ? 'rgba(0,0,0,0.25)' : '#ffffff',
    ...draggableStyle
});

const getListStyle = isDraggingOver => ({
    background: isDraggingOver ? 'lightgrey' : 'lightgrey',
    padding: grid,
    height:450,
    overflowY:'scroll',
    width:'80%'
});

class CreateOrUpdateTemplate extends Component {

    constructor(props){
        super(props);
        this.state = {
            items: [],
            selected: [],
            action:this.props.match.params.action,
            templateName:undefined,
            isFetching:true,
            showMessage:false,
            validTemplateName:true
        }
    }

    id2List = {
        droppable: 'items',
        droppable2: 'selected'
    };

    componentWillMount() {
        if(this.props.match.params.action === 'create'){
            getModulesList().then((list)=>{this.setState({items:list['custom_modules'],selected:list['system_modules']})});
        }
        if(this.props.match.params.action === 'update' && this.props.match.params.templateId){
            getTemplateDetails(this.props.match.params.templateId).then((response)=>{
                if(response.success){
                    this.setState({selected:response.data['report_template']['selected_modules'],items:response.data['report_template']['report_modules'],templateName:response.data['report_template']['name'],action:'update'})
                }});
        }
    }

    getList = id => this.state[this.id2List[id]];

    onDragEnd = result => {
        const { source, destination } = result;

        if (!destination) {
            return;
        }
        if(result.draggableId.split("##")[1] === 'system' && source.droppableId !== destination.droppableId){
            return;
        }

        if (source.droppableId === destination.droppableId) {
            const items = reorder(
                this.getList(source.droppableId),
                source.index,
                destination.index
            );

            let state = { items };

            if (source.droppableId === 'droppable2') {
                state = { selected: items };
            }

            this.setState(state);
        } else {
            const result = move(
                this.getList(source.droppableId),
                this.getList(destination.droppableId),
                source,
                destination
            );

            this.setState({
                items: result.droppable,
                selected: result.droppable2
            });
        }
    };

    handleSubmit = () => {
        if(this.state.templateName.length < 2){
            this.setState({validTemplateName:false});
            return;
        }
      let selectedModules =[];
      for(let i=0;i<this.state.selected.length;i++){
          let obj = {
              report_module_id:this.state.selected[i].id,
              position:i
          };
          selectedModules.push(obj);
      }
      let formData = {};
      if(this.state.action === 'update'){
          formData = {
                id:this.props.match.params.templateId,
                name:this.state.templateName,
                report_modules:selectedModules
            };
      }
      else {
          formData = {
              name:this.state.templateName,
              report_modules:selectedModules
          };
      }
      this.props.addOrUpdateTemplate(this.state.action,formData,this.successCallBack)
    };

    successCallBack = (response) => {
        if (response.success) {
            this.setState({showMessage:true});
            setTimeout(() => {if(this.state.action === 'create'){this.props.history.replace('/report/template/list')}},3000)
        }
    };

    render() {
        const templateName = this.state.templateName;
        return (
            <div style={{width:'80%',margin:'auto'}}>
                <Header size="large" content="Report Template" />
                {this.state.showMessage && <Message positive onDismiss={() => {this.setState({showMessage:false})}}>
                    <Message.Header>
                        {this.state.action === 'create' ?"Template creation successful!":"Template updated successfully!"}
                    </Message.Header>
                </Message>}
                <div style={{width:'80%'}}>
                    <Form>
                    <Form.Input
                        required
                        label="Template Name"
                        fluid
                        error={!this.state.validTemplateName}
                        value={templateName?templateName:undefined}
                        onFocus ={(e)=>{this.setState({templateName:e.target.value,validTemplateName:true})}}
                        onChange={(e)=>{this.setState({templateName:e.target.value})}}
                        />
                    </Form>
                </div>
            <DragDropContext onDragEnd={this.onDragEnd}>
                <Grid>
                    <Grid.Row columns={2}>
                        <Grid.Column width={8} >
                    <Header content="Available Modules"/>
                    <Droppable droppableId="droppable">
                        {(provided, snapshot) => (
                            <div
                                ref={provided.innerRef}
                                style={getListStyle(snapshot.isDraggingOver)}>
                                {this.state.items && this.state.items.map((item, index) => (
                                    <Draggable
                                        key={item.id}
                                        draggableId={item.id+"##"+item['type']}
                                        index={index}>
                                        {(provided, snapshot) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                style={getItemStyle(
                                                    snapshot.isDragging,
                                                    provided.draggableProps.style
                                                )}>
                                                <Icon name="bars" size="large"/>&nbsp; {item.name}
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                        </Grid.Column>
                        <Grid.Column width={8}>
                    <Header content="Selected Modules"/>
                    <Droppable droppableId="droppable2">
                        {(provided, snapshot) => (
                            <div
                                ref={provided.innerRef}
                                style={getListStyle(snapshot.isDraggingOver)}>
                                {this.state.selected && this.state.selected.map((item, index) => (
                                    <Draggable
                                        key={item.name}
                                        draggableId={item.name+"##"+item['type']}
                                        index={index}>
                                        {(provided, snapshot) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                style={getItemStyle(
                                                    snapshot.isDragging,
                                                    provided.draggableProps.style
                                                )}>
                                                <Icon name="bars" size="large"/> &nbsp;{item.name}
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </DragDropContext>
                <div className="additional-pad right-aligned pad-bottom" style={{}}>
                    <Button primary content="Save Template" onClick={this.handleSubmit}/>
                </div>
            </div>
        );
    }
}

export default ReportTemplatesContainer(CreateOrUpdateTemplate);


// WEBPACK FOOTER //
// ./src/views/report/templates/create_or_update_template.js